
import React from 'react';
import LeagueTableCard from './LeagueTableCard';
import TeamDetailsCard from './TeamDetailsCard';
import ResultsCard from './ResultsCard';
import CompareCard from './CompareCard';
import OddsAnalysisCard from './OddsAnalysisCard';

interface CardSectionProps {
  selectedCountry: string | null;
  selectedLeague: string | null;
  selectedYear: string | null;
  resultsCountry: string | null;
  resultsLeague: string | null;
  orderedCountries: string[];
  availableLeagues: string[];
  availableYears: string[];
  resultsAvailableLeagues: string[];
  onCountrySelect: (country: string) => void;
  onLeagueSelect: (league: string) => void;
  onYearSelect: (year: string) => void;
  setResultsCountry: (country: string | null) => void;
  handleResultsLeagueSelect: (league: string) => string;
  handleTabChange: (value: string) => void;
  handleLatestClick: () => void;
}

export const CardSection: React.FC<CardSectionProps> = ({
  selectedCountry,
  selectedLeague,
  selectedYear,
  resultsCountry,
  resultsLeague,
  orderedCountries,
  availableLeagues,
  availableYears,
  resultsAvailableLeagues,
  onCountrySelect,
  onLeagueSelect,
  onYearSelect,
  setResultsCountry,
  handleResultsLeagueSelect,
  handleTabChange,
  handleLatestClick,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      <div className="h-full">
        <LeagueTableCard
          selectedCountry={selectedCountry}
          selectedLeague={selectedLeague}
          selectedYear={selectedYear}
          onCountrySelect={onCountrySelect}
          onLeagueSelect={onLeagueSelect}
          onYearSelect={onYearSelect}
          availableLeagues={availableLeagues}
          availableYears={availableYears}
        />
      </div>

      <div className="h-full">
        <TeamDetailsCard />
      </div>

      <div className="h-full">
        <ResultsCard
          resultsCountry={resultsCountry}
          resultsLeague={resultsLeague}
          orderedCountries={orderedCountries}
          resultsAvailableLeagues={resultsAvailableLeagues}
          setResultsCountry={setResultsCountry}
          handleResultsLeagueSelect={handleResultsLeagueSelect}
          handleTabChange={handleTabChange}
          handleLatestClick={handleLatestClick}
        />
      </div>

      <div className="h-full sm:col-span-1 lg:col-span-1">
        <OddsAnalysisCard />
      </div>

      <div className="h-full sm:col-span-2 lg:col-span-1">
        <CompareCard />
      </div>
    </div>
  );
};

export default CardSection;
